module.exports = __webpack_public_path__ + "img/small_whale31.519bac39.jpg";